<template>
  <component :is="componentName" :model="this.model" />
</template>
<script>
import { FormModes } from '@/models/enums'
import Support from './ContentType.SupportForm.vue'
import SedForm from './ContentType.SedForm.vue'
import TechSupportForm from './ContentType.TechSupportForm.vue'
import DeletePersonaInformationForm from './ContentType.DeletePersonaInformationForm.vue'
import ConsultationForm from './ContentType.ConsultationForm.vue'
import RequestDraftAgreementForm from './ContentType.RequestDraftAgreementForm.vue'
export default {
  name: 'Forms',
  components: {
    Support,
    SedForm,
    TechSupportForm,
    DeletePersonaInformationForm,
    ConsultationForm,
    RequestDraftAgreementForm
  },
  props: {
    model: Object
  },
  computed: {
    componentName: function () {
      switch (this.model.metadata.mode) {
        case FormModes.SaleForm:
          return 'SedForm'
        case FormModes.TechSupportForm:
          return 'TechSupportForm'
        case FormModes.DeletePersonaInformationForm:
          return DeletePersonaInformationForm
        case FormModes.ConsultationForm:
          return 'ConsultationForm'
        case FormModes.RequestDraftAgreementForm:
          return 'RequestDraftAgreementForm'
        default:
          return 'Support'
      }
    }
  }
}
</script>
